import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from 'react-image-lightbox';
import { getLang } from 'src/lang';
import styled from 'styled-components';

import { FaqStyled } from './Faq.styled';

interface Props {
  question: any;
  id?: number;
}

const AnchorStyled = styled.a`
  display: block;
  position: relative;
  top: -150px;
  visibility: hidden;
`;

const altTextFromFilename = filename => {
  return filename.replaceAll('-', ' ').substring(0, filename.lastIndexOf('.'));
};

export const FaqQuestion = (props: Props) => {
  const { t } = useTranslation();
  const [showImageFullScreen, setShowImageFullScreen] = useState(false);
  const [imageFullScreen, setImageFullScreen] = useState('');
  return (
    <>
      {showImageFullScreen && (
        <Lightbox
          mainSrc={require(`../../assets/${imageFullScreen}`)}
          onCloseRequest={() => setShowImageFullScreen(false)}
        />
      )}
      <AnchorStyled id={String(props.id)}></AnchorStyled>
      <FaqStyled.ContentContainer>
        {props.question.question && (
          <FaqStyled.Question
            dangerouslySetInnerHTML={{
              __html: t(props.question.question)
            }}
          ></FaqStyled.Question>
        )}
        <FaqStyled.Answer
          dangerouslySetInnerHTML={{
            __html: props.question.answer
          }}
        ></FaqStyled.Answer>
        {props.question.image && (
          <FaqStyled.Image
            src={require(`../../assets/${props.question.image}`)}
            onClick={(): void => {
              setImageFullScreen(props.question.image);
              setShowImageFullScreen(true);
            }}
          />
        )}
        {props.question.customBlockName === 'correct-incorrect' && (
          <FaqStyled.FaqImageWrapper>
            <FaqStyled.FaqImageBox lang={getLang()}>
              <FaqStyled.FaqImage
                src={require(`../../assets/${props.question.correctImage}`)}
              />
              <FaqStyled.FaqImageCheckmarkBox isTick={true}>
                <FaqStyled.FaqImageCheckmark />
              </FaqStyled.FaqImageCheckmarkBox>
              <FaqStyled.FaqImageText isCorrect={true}>
                {props.question.correctText}
              </FaqStyled.FaqImageText>
            </FaqStyled.FaqImageBox>
            <FaqStyled.FaqImageBox lang={getLang()}>
              <FaqStyled.FaqImage
                src={require(`../../assets/${props.question.incorrectImage}`)}
              />
              <FaqStyled.FaqImageCheckmarkBox isTick={false}>
                <FaqStyled.FaqImageCheckmarkCross />
              </FaqStyled.FaqImageCheckmarkBox>
              <FaqStyled.FaqImageText isCorrect={false}>
                {props.question.incorrectText}
              </FaqStyled.FaqImageText>
            </FaqStyled.FaqImageBox>
          </FaqStyled.FaqImageWrapper>
        )}
        {props.question.buttonImage1 && props.question.buttonImage2 && (
          <FaqStyled.ButtonContainer>
            <a
              href={props.question.buttonLink1}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <img
                alt={`${altTextFromFilename(props.question.buttonImage1)}`}
                src={require(`../../assets/${props.question.buttonImage1}`)}
              />
            </a>
            <a
              href={props.question.buttonLink2}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <img
                alt={`${altTextFromFilename(props.question.buttonImage2)}`}
                src={require(`../../assets/${props.question.buttonImage2}`)}
              />
            </a>
          </FaqStyled.ButtonContainer>
        )}
        {props.question.gif1 && props.question.gif2 && (
          <FaqStyled.CardGray>
            <FaqStyled.ButtonContainer>
              <div>
                <div
                  style={{
                    margin: 16,
                    position: 'relative',
                    float: 'right',
                    paddingRight: 5
                  }}
                >
                  <FaqStyled.GifGreen
                    src={require(`../../assets/${props.question.gif1}`)}
                  />
                  <img
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0
                    }}
                    src={require('../../assets/icon-correct.svg')}
                  ></img>
                </div>
                <FaqStyled.GifTitleGreen>
                  {props.question.gif1Text}
                </FaqStyled.GifTitleGreen>
              </div>
              <div>
                <div
                  style={{
                    margin: 16,
                    position: 'relative',
                    float: 'right',
                    paddingRight: 5
                  }}
                >
                  <FaqStyled.GifRed
                    src={require(`../../assets/${props.question.gif2}`)}
                  />
                  <img
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0
                    }}
                    src={require('../../assets/icon-wrong.svg')}
                  ></img>
                </div>
                <FaqStyled.GifTitleGray>
                  {props.question.gif2Text}
                </FaqStyled.GifTitleGray>
              </div>
            </FaqStyled.ButtonContainer>
          </FaqStyled.CardGray>
        )}
      </FaqStyled.ContentContainer>
    </>
  );
};
